import script from "./TireApprovalsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TireApprovalsView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__